import type { SnapCategory } from '@/types/database.types';
import { getCategoryColor } from '@/utils/snap';

interface CategoryTagsProps {
  categories: SnapCategory[];
  className?: string;
  variant?: 'default' | 'white';
}

export default function CategoryTags({ categories, className = '', variant = 'default' }: CategoryTagsProps) {
  if (!Array.isArray(categories)) return null;

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {categories.map((category) => {
        const colors = getCategoryColor(category);
        return (
          <span
            key={category}
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize ${
              variant === 'white' 
                ? 'bg-white/20' 
                : `${colors.bg} ${colors.text}`
            }`}
          >
            <span className="mr-1">{colors.icon}</span>
            {category.replace('_', ' ')}
          </span>
        );
      })}
    </div>
  );
}